import iconAquarius from 'icon/win10/aquarius.svg?component'
import iconAries from 'icon/win10/aries.svg?component'
import iconCancer from 'icon/win10/cancer.svg?component'
import iconCapricorn from 'icon/win10/capricorn.svg?component'
import iconGemini from 'icon/win10/gemini.svg?component'
import iconLeo from 'icon/win10/leo.svg?component'
import iconLibra from 'icon/win10/libra.svg?component'
import iconMercury from 'icon/win10/mercury.svg?component'
import iconPisces from 'icon/win10/pisces.svg?component'
import iconSagittarius from 'icon/win10/sagittarius.svg?component'
import iconScorpio from 'icon/win10/scorpio.svg?component'
import iconTaurus from 'icon/win10/taurus.svg?component'
import iconVirgo from 'icon/win10/virgo.svg?component'
import getDay from 'date-fns__legacy__/get_day'
import getMonth from 'date-fns__legacy__/get_month'

const getIcon = (sign) => ({
  aquarius: iconAquarius,
  aries: iconAries,
  cancer: iconCancer,
  capricorn: iconCapricorn,
  gemini: iconGemini,
  leo: iconLeo,
  libra: iconLibra,
  mercury: iconMercury,
  pisces: iconPisces,
  sagittarius: iconSagittarius,
  scorpio: iconScorpio,
  taurus: iconTaurus,
  virgo: iconVirgo,
}[sign])

const getName = (month, day) => ({
  1:  day <= 19 ? 'capricorn' : 'aquarius',
  2:  day <= 18 ? 'aquarius' : 'pisces',
  3:  day <= 20 ? 'pisces' : 'aries',
  4:  day <= 19 ? 'aries' : 'taurus',
  5:  day <= 20 ? 'taurus' : 'gemini',
  6:  day <= 20 ? 'gemini' : 'cancer',
  7:  day <= 22 ? 'cancer' : 'leo',
  8:  day <= 22 ? 'leo' : 'virgo',
  9:  day <= 22 ? 'virgo' : 'libra',
  10: day <= 22 ? 'libra' : 'scorpio',
  11: day <= 21 ? 'scorpio' : 'sagittarius',
  12: day <= 21 ? 'sagittarius' : 'capricorn',
}[month])

export const getZodiacIcon = (date) => {
  const day = getDay(date)
  const month = getMonth(date)

  const name = getName(day,month)
  const icon = getIcon(name)

  return icon
}

export default { getZodiacIcon }